module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-10.9a7f9f68.png";